<template>
  <div class="TutorModal">
    <a @click="getData">印刷</a>
    <component-modal v-show="condition.condition" transition="expand">
      <template slot="title">印刷 : {{user.user}}</template>
      <div slot="body" class="wrapper">
        <div class="table">
          <div class="tr">
            <div class="th">ID</div>
            <div class="td">{{tutor.id}}</div>
          </div>
          <div class="tr">
            <div class="th">状態</div>
            <div class="td" v-if="tutor.state === 0">未選択</div>
            <div class="td" v-if="tutor.state === 1">指導可</div>
            <div class="td" v-if="tutor.state === 2">指導不可</div>
          </div>
          <div class="tr">
            <div class="th">登録日</div>
            <div class="td">{{tutor.registration_date}}</div>
          </div>
          <div class="tr">
            <div class="th">名前</div>
            <div class="td">{{tutor.f_name}} {{tutor.l_name}}</div>
          </div>
          <div class="tr">
            <div class="th">かな</div>
            <div class="td">{{tutor.f_name_kana}} {{tutor.l_name_kana}}</div>
          </div>
          <div class="tr">
            <div class="th">性別</div>
            <div class="td" v-if="tutor.gender === 0">未選択</div>
            <div class="td" v-if="tutor.gender === 1">男</div>
            <div class="td" v-if="tutor.gender === 2">女</div>
          </div>
          <div class="tr">
            <div class="th">生年月日</div>
            <div class="td">{{tutor.birthday}}</div>
          </div>
          <div class="tr">
            <div class="th">年齢</div>
            <div class="td">{{calcAge}}</div>
          </div>
          <div class="tr">
            <div class="th">郵便番号</div>
            <div class="td">{{tutor.zip}}</div>
          </div>
          <div class="tr">
            <div class="th">都道府県</div>
            <div class="td">
              <template v-if="tutor.pref === 0">未選択</template>
              <template v-if="tutor.pref === 1">北海道</template>
              <template v-if="tutor.pref === 2">青森県</template>
              <template v-if="tutor.pref === 3">秋田県</template>
              <template v-if="tutor.pref === 4">岩手県</template>
              <template v-if="tutor.pref === 5">山形県</template>
              <template v-if="tutor.pref === 6">宮城県</template>
              <template v-if="tutor.pref === 7">福島県</template>
              <template v-if="tutor.pref === 8">栃木県</template>
              <template v-if="tutor.pref === 9">山梨県</template>
              <template v-if="tutor.pref === 10">群馬県</template>
              <template v-if="tutor.pref === 11">茨城県</template>
              <template v-if="tutor.pref === 12">千葉県</template>
              <template v-if="tutor.pref === 13">埼玉県</template>
              <template v-if="tutor.pref === 14">東京都</template>
              <template v-if="tutor.pref === 15">神奈川県</template>
              <template v-if="tutor.pref === 16">静岡県</template>
              <template v-if="tutor.pref === 17">長野県</template>
              <template v-if="tutor.pref === 18">愛知県</template>
              <template v-if="tutor.pref === 19">岐阜県</template>
              <template v-if="tutor.pref === 20">新潟県</template>
              <template v-if="tutor.pref === 21">富山県</template>
              <template v-if="tutor.pref === 22">石川県</template>
              <template v-if="tutor.pref === 23">福井県</template>
              <template v-if="tutor.pref === 24">滋賀県</template>
              <template v-if="tutor.pref === 25">京都府</template>
              <template v-if="tutor.pref === 26">三重県</template>
              <template v-if="tutor.pref === 27">和歌山県</template>
              <template v-if="tutor.pref === 28">奈良県</template>
              <template v-if="tutor.pref === 29">大阪府</template>
              <template v-if="tutor.pref === 30">兵庫県</template>
              <template v-if="tutor.pref === 31">鳥取県</template>
              <template v-if="tutor.pref === 32">島根県</template>
              <template v-if="tutor.pref === 33">岡山県</template>
              <template v-if="tutor.pref === 34">広島県</template>
              <template v-if="tutor.pref === 35">山口県</template>
              <template v-if="tutor.pref === 36">高知県</template>
              <template v-if="tutor.pref === 37">徳島県</template>
              <template v-if="tutor.pref === 38">香川県</template>
              <template v-if="tutor.pref === 39">愛媛県</template>
              <template v-if="tutor.pref === 40">福岡県</template>
              <template v-if="tutor.pref === 41">佐賀県</template>
              <template v-if="tutor.pref === 42">長崎県</template>
              <template v-if="tutor.pref === 43">熊本県</template>
              <template v-if="tutor.pref === 44">宮崎県</template>
              <template v-if="tutor.pref === 45">大分県</template>
              <template v-if="tutor.pref === 46">鹿児島県</template>
              <template v-if="tutor.pref === 47">沖縄県</template>
            </div>
          </div>
          <div class="tr">
            <div class="th">市区町村・番地</div>
            <div class="td">{{tutor.address1}}</div>
          </div>
          <div class="tr">
            <div class="th">建物名・部屋番号</div>
            <div class="td">{{tutor.address2}}</div>
          </div>
          <div class="tr">
            <div class="th">TEL1</div>
            <div class="td">{{tutor.tel1}}</div>
          </div>
          <div class="tr">
            <div class="th">TEL2</div>
            <div class="td">{{tutor.tel2}}</div>
          </div>
          <div class="tr">
            <div class="th">MAIL1</div>
            <div class="td">{{tutor.mail1}}</div>
          </div>
          <div class="tr">
            <div class="th">MAIL2</div>
            <div class="td">{{tutor.mail2}}</div>
          </div>
          <div class="tr">
            <div class="th">実家郵便番号</div>
            <div class="td">{{tutor.home_zip}}</div>
          </div>
          <div class="tr">
            <div class="th">実家/都道府県</div>
            <div class="td">
              <template v-if="tutor.home_pref === 0">未選択</template>
              <template v-if="tutor.home_pref === 1">北海道</template>
              <template v-if="tutor.home_pref === 2">青森県</template>
              <template v-if="tutor.home_pref === 3">秋田県</template>
              <template v-if="tutor.home_pref === 4">岩手県</template>
              <template v-if="tutor.home_pref === 5">山形県</template>
              <template v-if="tutor.home_pref === 6">宮城県</template>
              <template v-if="tutor.home_pref === 7">福島県</template>
              <template v-if="tutor.home_pref === 8">栃木県</template>
              <template v-if="tutor.home_pref === 9">山梨県</template>
              <template v-if="tutor.home_pref === 10">群馬県</template>
              <template v-if="tutor.home_pref === 11">茨城県</template>
              <template v-if="tutor.home_pref === 12">千葉県</template>
              <template v-if="tutor.home_pref === 13">埼玉県</template>
              <template v-if="tutor.home_pref === 14">東京都</template>
              <template v-if="tutor.home_pref === 15">神奈川県</template>
              <template v-if="tutor.home_pref === 16">静岡県</template>
              <template v-if="tutor.home_pref === 17">長野県</template>
              <template v-if="tutor.home_pref === 18">愛知県</template>
              <template v-if="tutor.home_pref === 19">岐阜県</template>
              <template v-if="tutor.home_pref === 20">新潟県</template>
              <template v-if="tutor.home_pref === 21">富山県</template>
              <template v-if="tutor.home_pref === 22">石川県</template>
              <template v-if="tutor.home_pref === 23">福井県</template>
              <template v-if="tutor.home_pref === 24">滋賀県</template>
              <template v-if="tutor.home_pref === 25">京都府</template>
              <template v-if="tutor.home_pref === 26">三重県</template>
              <template v-if="tutor.home_pref === 27">和歌山県</template>
              <template v-if="tutor.home_pref === 28">奈良県</template>
              <template v-if="tutor.home_pref === 29">大阪府</template>
              <template v-if="tutor.home_pref === 30">兵庫県</template>
              <template v-if="tutor.home_pref === 31">鳥取県</template>
              <template v-if="tutor.home_pref === 32">島根県</template>
              <template v-if="tutor.home_pref === 33">岡山県</template>
              <template v-if="tutor.home_pref === 34">広島県</template>
              <template v-if="tutor.home_pref === 35">山口県</template>
              <template v-if="tutor.home_pref === 36">高知県</template>
              <template v-if="tutor.home_pref === 37">徳島県</template>
              <template v-if="tutor.home_pref === 38">香川県</template>
              <template v-if="tutor.home_pref === 39">愛媛県</template>
              <template v-if="tutor.home_pref === 40">福岡県</template>
              <template v-if="tutor.home_pref === 41">佐賀県</template>
              <template v-if="tutor.home_pref === 42">長崎県</template>
              <template v-if="tutor.home_pref === 43">熊本県</template>
              <template v-if="tutor.home_pref === 44">宮崎県</template>
              <template v-if="tutor.home_pref === 45">大分県</template>
              <template v-if="tutor.home_pref === 46">鹿児島県</template>
              <template v-if="tutor.home_pref === 47">沖縄県</template>
            </div>
          </div>
          <div class="tr">
            <div class="th">実家/市区町村・番地</div>
            <div class="td">{{tutor.home_address1}}</div>
          </div>
          <div class="tr">
            <div class="th">実家/建物名・部屋番号</div>
            <div class="td">{{tutor.home_address2}}</div>
          </div>
          <div class="tr">
            <div class="th">実家TEL</div>
            <div class="td">{{tutor.home_tel}}</div>
          </div>
          <div class="tr">
            <div class="th">学校名</div>
            <div class="td">{{tutor.school_name}}</div>
          </div>
          <div class="tr">
            <div class="th">区分</div>
            <div class="td" v-if="tutor.school_stage === 0">未選択</div>
            <div class="td" v-if="tutor.school_stage === 1">大学4年制</div>
            <div class="td" v-if="tutor.school_stage === 2">大学院</div>
            <div class="td" v-if="tutor.school_stage === 3">専門2年制</div>
            <div class="td" v-if="tutor.school_stage === 4">高校</div>
            <div class="td" v-if="tutor.school_stage === 5">大学6年制</div>
            <div class="td" v-if="tutor.school_stage === 6">専門3年制</div>
            <div class="td" v-if="tutor.school_stage === 7">短大2年制</div>
            <div class="td" v-if="tutor.school_stage === 8">高専</div>
            <div class="td" v-if="tutor.school_stage === 9">大学</div>
            <div class="td" v-if="tutor.school_stage === 10">専門</div>
          </div>
          <div class="tr">
            <div class="th">学部</div>
            <div class="td">{{tutor.department}}</div>
          </div>
          <div class="tr">
            <div class="th">学年</div>
            <div class="td">{{calcGrade}}</div>
          </div>
          <div class="tr">
            <div class="th">旧学年</div>
            <div class="td" v-if="tutor.grade === 0">未選択</div>
            <div class="td" v-if="tutor.grade === 1">1</div>
            <div class="td" v-if="tutor.grade === 2">2</div>
            <div class="td" v-if="tutor.grade === 3">3</div>
            <div class="td" v-if="tutor.grade === 4">4</div>
            <div class="td" v-if="tutor.grade === 5">5</div>
            <div class="td" v-if="tutor.grade === 6">6</div>
            <div class="td" v-if="tutor.grade === 7">M1</div>
            <div class="td" v-if="tutor.grade === 8">M2</div>
            <div class="td" v-if="tutor.grade === 9">D1</div>
            <div class="td" v-if="tutor.grade === 10">D2</div>
            <div class="td" v-if="tutor.grade === 11">卒業</div>
            <div class="td" v-if="tutor.grade === 12">中退</div>
          </div>
          <div class="tr">
            <div class="th">文系/理系</div>
            <div class="td" v-if="tutor.department_type === 0">未選択</div>
            <div class="td" v-if="tutor.department_type === 1">文系</div>
            <div class="td" v-if="tutor.department_type === 2">理系</div>
            <div class="td" v-if="tutor.department_type === 3">他</div>
          </div>
          <div class="tr">
            <div class="th">サークル</div>
            <div class="td">{{tutor.club}}</div>
          </div>
          <div class="tr">
            <div class="th">高校部活</div>
            <div class="td">{{tutor.high_school_club}}</div>
          </div>
          <div class="tr">
            <div class="th">出身高校</div>
            <div class="td">{{tutor.high_school_name}}</div>
          </div>
          <div class="tr">
            <div class="th">車</div>
            <div class="td" v-if="tutor.transportation_car === 0">無</div>
            <div class="td" v-if="tutor.transportation_car === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">バイク</div>
            <div class="td" v-if="tutor.transportation_bike === 0">無</div>
            <div class="td" v-if="tutor.transportation_bike === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">原付</div>
            <div class="td" v-if="tutor.transportation_scooters === 0">無</div>
            <div class="td" v-if="tutor.transportation_scooters === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">自転車</div>
            <div class="td" v-if="tutor.transportation_bicycle === 0">無</div>
            <div class="td" v-if="tutor.transportation_bicycle === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">電車</div>
            <div class="td" v-if="tutor.transportation_train === 0">NG</div>
            <div class="td" v-if="tutor.transportation_train === 1">OK</div>
          </div>
          <div class="tr">
            <div class="th">最寄駅</div>
            <div class="td">{{tutor.nearest_station}}</div>
          </div>
          <div class="tr">
            <div class="th">小学受験</div>
            <div class="td" v-if="tutor.exam_s === 0">無</div>
            <div class="td" v-if="tutor.exam_s === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">中学受験</div>
            <div class="td" v-if="tutor.exam_c === 0">無</div>
            <div class="td" v-if="tutor.exam_c === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">高学受験</div>
            <div class="td" v-if="tutor.exam_k === 0">無</div>
            <div class="td" v-if="tutor.exam_k === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">大学受験</div>
            <div class="td" v-if="tutor.exam_d === 0">無</div>
            <div class="td" v-if="tutor.exam_d === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">家庭教師経験</div>
            <div class="td" v-if="tutor.experience_tutor === 0">無</div>
            <div class="td" v-if="tutor.experience_tutor === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">備考</div>
            <div class="td">{{tutor.experience_tutor_note}}</div>
          </div>
          <div class="tr">
            <div class="th">塾講師経験</div>
            <div class="td" v-if="tutor.experience_cram === 0">無</div>
            <div class="td" v-if="tutor.experience_cram === 1">有</div>
          </div>
          <div class="tr">
            <div class="th">備考</div>
            <div class="td">{{tutor.experience_cram_note}}</div>
          </div>
          <div class="tr">
            <div class="th">登録媒体</div>
            <div class="td" v-if="tutor.medium === 0">未選択</div>
            <div class="td" v-if="tutor.medium === 1">Sensay</div>
            <div class="td" v-if="tutor.medium === 2">TownWork</div>
            <div class="td" v-if="tutor.medium === 3">PA</div>
            <div class="td" v-if="tutor.medium === 4">an</div>
            <div class="td" v-if="tutor.medium === 5">バイトル</div>
            <div class="td" v-if="tutor.medium === 6">キャンパスライフ</div>
            <div class="td" v-if="tutor.medium === 7">紹介</div>
            <div class="td" v-if="tutor.medium === 8">HP</div>
            <div class="td" v-if="tutor.medium === 9">掲示板</div>
            <div class="td" v-if="tutor.medium === 10">LINE</div>
            <div class="td" v-if="tutor.medium === 11">マイナビ</div>
            <div class="td" v-if="tutor.medium === 12">Indeed</div>
          </div>
          <div class="tr">
            <div class="th">備考</div>
            <div class="td">{{tutor.medium_note}}</div>
          </div>
          <div class="tr">
            <div class="th">HP/パンフ掲載</div>
            <div class="td" v-if="tutor.published === 0">未選択</div>
            <div class="td" v-if="tutor.published === 1">OK</div>
            <div class="td" v-if="tutor.published === 2">NG</div>
          </div>
          <div class="tr">
            <div class="th">情報発信</div>
            <div class="td" v-if="tutor.information === 0">未選択</div>
            <div class="td" v-if="tutor.information === 1">OK</div>
            <div class="td" v-if="tutor.information === 2">NG</div>
          </div>
          <div class="tr">
            <div class="th">印象ランク</div>
            <div class="td" v-if="tutor.impression === 0">未選択</div>
            <div class="td" v-if="tutor.impression === 1">AA</div>
            <div class="td" v-if="tutor.impression === 2">A</div>
            <div class="td" v-if="tutor.impression === 3">B</div>
            <div class="td" v-if="tutor.impression === 4">C</div>
            <div class="td" v-if="tutor.impression === 5">Z</div>
            <div class="td" v-if="tutor.impression === 6">紹介不可</div>
          </div>
          <div class="tr">
            <div class="th">印象ランク備考</div>
            <div class="td">{{tutor.impression_note}}</div>
          </div>
          <div class="tr">
            <div class="th">研修</div>
            <div class="td" v-if="tutor.training === 0">未</div>
            <div class="td" v-if="tutor.training === 1">済</div>
          </div>
          <div class="tr">
            <div class="th">研修備考</div>
            <div class="td">{{tutor.training_note}}</div>
          </div>
          <div class="tr">
            <div class="th">SSK</div>
            <div class="td" v-if="tutor.ssk === 0">未</div>
            <div class="td" v-if="tutor.ssk === 1">済</div>
          </div>
          <div class="tr">
            <div class="th">備考</div>
            <div class="td">{{tutor.note}}</div>
          </div>
        </div>
      </div>
      <div class="footer" slot="footer">
        <btn @click.native="showModal">キャンセル</btn>
      </div>
    </component-modal>
  </div>
</template>

<script>
export default {
  name: 'TutorModal',
  props: {
    tutor: Object
  },
  data () {
    return {
      condition: {
        condition: false
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },

    calcAge () {
      let x = Date.parse(this.tutor.birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade () {
      let self = this
      let x = Date.parse(self.tutor.birthday) // 変換(ミリ秒が返される)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      let gradeNumber = ageNumber + Number(self.tutor.grade_flag)

      let grade
      if (gradeNumber === 4) {
        grade = '幼稚園年少'
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'
      } else if (gradeNumber === 7) {
        grade = '小学1年生'
      } else if (gradeNumber === 8) {
        grade = '小学2年生'
      } else if (gradeNumber === 9) {
        grade = '小学3年生'
      } else if (gradeNumber === 10) {
        grade = '小学4年生'
      } else if (gradeNumber === 11) {
        grade = '小学5年生'
      } else if (gradeNumber === 12) {
        grade = '小学6年生'
      } else if (gradeNumber === 13) {
        grade = '中学1年生'
      } else if (gradeNumber === 14) {
        grade = '中学2年生'
      } else if (gradeNumber === 15) {
        grade = '中学3年生'
      } else if (gradeNumber === 16) {
        grade = '高校1年生'
      } else if (gradeNumber === 17) {
        grade = '高校2年生'
      } else if (gradeNumber === 18) {
        grade = '高校3年生'
      } else if (gradeNumber === 19) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門1年生'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学1年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門1年生'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大1年生'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専4年生'
        }
      } else if (gradeNumber === 20) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年生'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学2年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門2年生'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年生'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専5年生'
        }
      } else if (gradeNumber === 21) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学3年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年生'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        }
      } else if (gradeNumber === 22) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学4年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        }
      } else if (gradeNumber === 23) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学M1'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学5年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        }
      } else if (gradeNumber === 24) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学M2'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年生'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        }
      } else if (gradeNumber === 0) {
        if (self.tutor.school_stage === 0) {
          grade = '区分未選択'
        } else if (self.tutor.school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (self.tutor.school_stage === 2) {
          grade = '大学院卒業'
        } else if (self.tutor.school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (self.tutor.school_stage === 4) {
          grade = '高校卒業'
        } else if (self.tutor.school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (self.tutor.school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (self.tutor.school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (self.tutor.school_stage === 8) {
          grade = '高専卒業'
        }
      } else {
        grade = ''
      }
      return grade
    }
  },
  watch: {
  },
  methods: {
    showModal () {
      this.condition.condition = !this.condition.condition
    },

    getData () {
      this.condition.condition = !this.condition.condition
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss' scoped>
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.wrapper {
  display: flex;
  height: 570px;
  width: 1000px;
  border-top: solid 1px #ccc;
}
.table {
  display: flex;
  flex-flow: column wrap;
  .tr {
    width: 333px;
    border-top: none;
    border-bottom: solid 1px #ccc;
    border-right: solid 1px #ccc;
    border-left: solid 1px #ccc;
    display: flex;
    .th {
      width: 150px;
      background: #f4f4f4;
      color: #333;
      padding: 5px;
    }
    .td {
      width: 183px;
      padding: 5px;
      word-wrap: break-word;
    }
  }
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
</style>

<style lang="scss">
.TutorModal {
  .m-modal__inner {
    /* width: 100vw; */
  }
}
</style>



// WEBPACK FOOTER //
// TutorModal.vue?23217955